import React from 'react';
import { useDrop } from 'react-dnd';

import { map } from 'lodash';
import {
  arrayOf, bool, func, shape, string,
} from 'prop-types';
import { TYPES } from '../constants';
import CardSortItem from './card-sort-item';

import {
  Container,
  List,
  ScrollBar,
  Text,
} from './styles';

const CardSortItems = (props) => {
  const {
    items,
    onMoveItemBack,
    onMove,
    hideItemName,
    hideTooltip,
  } = props;

  const handleDrop = (item, monitor) => {
    const {
      id,
      cardSortCategoryId,
      itemOrder,
    } = item;

    const { index } = monitor.getDropResult() || { index: items.length };

    if (cardSortCategoryId) {
      onMoveItemBack(item, index);
      return;
    }

    if (itemOrder !== index) {
      onMove(id, index);
    }
  };

  const [, drop] = useDrop({
    accept: [TYPES.CARD_SORT_ITEM],
    drop: (item, monitor) => {
      handleDrop(item, monitor);
    },
    canDrop: ({ type }) => type === TYPES.CARD_SORT_ITEM,
  });

  return (
    <Container ref={drop}>
      <Text.Bold>
        Sort these cards into the groups on the right
      </Text.Bold>

      <List>
        <ScrollBar borderless>
          {map(items, (cardSortItem, index) => (
            <CardSortItem
              key={cardSortItem.id}
              cardSortItem={cardSortItem}
              cardSortItemIndex={index}
              onMove={onMove}
              hideItemName={hideItemName}
              hideTooltip={hideTooltip}
            />
          ))}
        </ScrollBar>
      </List>
    </Container>
  );
};

CardSortItems.propTypes = {
  onMoveItemBack: func.isRequired,
  onMove: func.isRequired,
  hideItemName: bool.isRequired,
  hideTooltip: bool.isRequired,
  items: arrayOf(
    shape({
      id: string,
    }),
  ).isRequired,
};

export default CardSortItems;
